import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import BrandLogo from "./BrandLogo";

// The top menu. Every item opens its own page.
const MENU = [
    { to: "/about-us", label: "About us" },
    { to: "/events", label: "Events" },
    { to: "/makuyu-prayer-center-booking", label: "Prayer center booking" },
    { to: "/support-the-ministry", label: "Support the ministry" },
];

// The header of the public pages (home, sign in, sign up, ...).
function Header() {
    const [user, setUser] = useState(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const userMenuRef = useRef(null);

    useEffect(() => {
        const loggedInUser = localStorage.getItem('user');
        if (loggedInUser && localStorage.getItem('access_token')) {
            try {
                setUser(JSON.parse(loggedInUser));
            } catch (error) {
                setUser(null);
            }
        }
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setIsUserMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const closeMenu = () => setIsMenuOpen(false);

    return (
        <header className="cf-head">
            <div className="cf-wrap cf-nav">
                <Link to="/" aria-label="CFCM Portal home" id="logoLink">
                    <BrandLogo />
                </Link>

                <nav className="cf-nav-links" aria-label="Main">
                    {MENU.map((item) => (
                        <NavLink to={item.to} key={item.to}>{item.label}</NavLink>
                    ))}
                </nav>

                <div className="cf-nav-cta">
                    {user ? (
                        <div className={`cf-user ${isUserMenuOpen ? "is-open" : ""}`} ref={userMenuRef}>
                            <button
                                type="button"
                                className="cf-btn cf-btn-ghost"
                                aria-haspopup="true"
                                aria-expanded={isUserMenuOpen}
                                onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                            >
                                {user.first_name} {user.last_name}
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
                            </button>
                            <div className="cf-user-menu" role="menu">
                                <Link to="/dashboard">Dashboard</Link>
                                <Link to="/dashboard/profile">Profile</Link>
                                <Link to="/logout">Log out</Link>
                            </div>
                        </div>
                    ) : (
                        <>
                            <Link className="cf-btn cf-btn-ghost" to="/login">Sign in</Link>
                            <Link className="cf-btn cf-btn-primary" to="/signup">Become a member</Link>
                        </>
                    )}
                </div>

                <button
                    type="button"
                    className="cf-burger"
                    aria-label="Menu"
                    aria-expanded={isMenuOpen}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
                </button>
            </div>

            <div className={`cf-mobile-menu ${isMenuOpen ? "is-open" : ""}`}>
                <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
                {MENU.map((item) => (
                    <NavLink to={item.to} key={item.to} onClick={closeMenu}>{item.label}</NavLink>
                ))}
                {user ? (
                    <>
                        <Link to="/dashboard" onClick={closeMenu}>Dashboard</Link>
                        <Link to="/dashboard/profile" onClick={closeMenu}>Profile</Link>
                        <Link to="/logout" onClick={closeMenu}>Log out</Link>
                    </>
                ) : (
                    <>
                        <Link to="/login" onClick={closeMenu}>Sign in</Link>
                        <Link className="cf-btn cf-btn-primary" to="/signup" onClick={closeMenu}>Become a member</Link>
                    </>
                )}
            </div>
        </header>
    );
}

export default Header;
